export default __webpack_public_path__ + "static/klaviatura-3b53574c02a686ba81d5632adb58018c.svg";